import { FC } from 'react';
import { IBlockBase } from '../../../endpoints/coachSessions';
import { BlockBase } from './BlockBase';
import styles from './BlockBase.module.scss';

interface BreakBlockProps {
  block: IBlockBase;
  index: number;
  onChange: (patch: Partial<IBlockBase>) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
}

/**
 * Tipo 4 — Pausa.
 * Blocco di pausa (acqua, spiegazione, riunione tattica).
 * EWT = 0, IPS = 0, CLS = 0.
 * Spec §4.4.
 */
export const BreakBlock: FC<BreakBlockProps> = ({
  block,
  index,
  onChange,
  onDelete,
  onDuplicate,
  onMoveUp,
  onMoveDown,
}) => {
  return (
    <BlockBase
      index={index}
      blockType="break"
      title={block.label ?? 'Pausa'}
      durationMinutes={block.durationMinutes}
      transitionAfterMinutes={block.transitionAfterMinutes}
      onTransitionChange={(v) => onChange({ transitionAfterMinutes: v })}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
    >
      <div className={styles.fieldGrid}>
        <div className={`${styles.field} ${styles.fieldFull}`}>
          <label className={styles.fieldLabel}>Etichetta pausa</label>
          <input
            className={styles.fieldInput}
            value={block.label ?? ''}
            onChange={(e) => onChange({ label: e.target.value })}
            placeholder="Es. Pausa acqua, Briefing tattico, Spiegazione drill…"
          />
        </div>
        <div className={styles.field}>
          <label className={styles.fieldLabel}>Durata (min)</label>
          <input
            className={styles.fieldInput}
            type="number"
            min={1}
            value={block.durationMinutes ?? ''}
            onChange={(e) =>
              onChange({ durationMinutes: Number(e.target.value) || undefined })
            }
          />
        </div>
      </div>
      <p
        style={{
          fontFamily: 'Satoshi, sans-serif',
          fontSize: 11,
          color: 'var(--c-text-3)',
          marginTop: 8,
          marginBottom: 0,
        }}
      >
        EWT = 0 · IPS = 0 · CLS = 0 (la pausa non contribuisce al carico)
      </p>
    </BlockBase>
  );
};
